(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/shared/components/start-page.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/shared/components/start-page.js');
'use strict';

const {
  WidgetArea
} = svs.components.tb_ui_react.widget_area;
const {
  AdvertiseCreateTeam
} = svs.arena.shared.components.widgetFallbacks;
const {
  routes
} = svs.arena.constants;
const StartPage = () => {
  const history = ReactRouterDOM.useHistory();
  const teams = ReactRedux.useSelector(state => state.teams.teams);
  if (teams.length > 0) {
    history.push(routes.TEAMS);
  }
  return React.createElement(React.Fragment, null, React.createElement(WidgetArea, {
    areaName: "arenaPageHero",
    fallback: React.createElement(AdvertiseCreateTeam, null)
  }), React.createElement(WidgetArea, {
    areaName: "arenaPageContent"
  }));
};
svs.arena.shared.components.StartPage = StartPage;

 })(window);